import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';


export const useQueryParams = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      host_app: params.get('host_app'),
      return_url: params.get('return_url'),
      ref: params.get('ref'),
    };
  }, [location.search]);

  
  const isIntegrationMode = useMemo(() => {
    return !!queryParams.host_app;
  }, [queryParams.host_app]);

  
  const handleExit = () => {
    if (queryParams.return_url) {
      // Redirect to external URL
      window.location.href = queryParams.return_url;
    } else if (queryParams.host_app) {
      // If host_app but no return_url, try to go back
      window.history.back();
    } else {
      // Default navigation
      navigate('/');
    }
  };

  
  const queryString = useMemo(() => {
    return location.search;
  }, [location.search]);

  return {
    queryParams,
    isIntegrationMode,
    handleExit,
    queryString,
    host_app: queryParams.host_app,
    return_url: queryParams.return_url,
    ref: queryParams.ref,
  };
};

export default useQueryParams;
